import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import { useAuth } from "../../context/AuthContext";
import { useUser } from "../../context/UserContext";
import { authenticateUser } from "../../services/LoginServices";

const RootLayoutPage = () => {
  const { updateUserData } = useUser();
  const {
    markUserAsLoggedIn,
    markUserAsAutheticatedByServer,
    onLogout
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // validate user status on page load with server side session
  useEffect(() => {
    const fetchUserStatus = async () => {
      const response = await authenticateUser();

      if (response.status == 1 && response.data.Autheticated === 1) {
        const { userInfo, group } = response.data;

        updateUserData({
          userInfo: {
            user_email: userInfo.user_email,
            first_name: userInfo.first_name,
            last_name: userInfo.last_name,
            phone_office: userInfo.phone_office,
            phone_mobile: userInfo.phone_mobile,
            organization: userInfo.organization,
            position: userInfo.position,
            language: userInfo.language,
          },
          group: group,
          isNewUser: userInfo.is_new,
        });

        markUserAsLoggedIn();
        markUserAsAutheticatedByServer();
            
        // navigate to dashboard changed tab to /, signin, userVerification or just
        // take to the url pasted in the address bar
        if (
          location.pathname === "/signin" ||
          location.pathname === "/userVerification"
        ) {
          navigate("/dashboard");
        }
      } else {
        onLogout();
      }
    };
    // Call it on component mount
    if (!location.pathname.startsWith("/schedule-confirmation")) {
      fetchUserStatus();
    }

    // Set up visibility and focus listeners
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && !location.pathname.startsWith("/schedule-confirmation")) {
        fetchUserStatus();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup listeners on unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location]);

  return (
    <main className="h-fit min-h-screen w-screen flex flex-col justify-between bg-neutral">
      <Header />
      <div className="main-container flex-grow">
        <div className="content-container py-[2px] px-[10px] sm:px-[50px] md:px-[100px] mb-8">
          <Outlet />
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default RootLayoutPage;
